import React from 'react';
import styled from 'styled-components';
import WifiAndroidIcon from '../../../assets/departureWifi/icon_wifi_and.png';
import SettingAndroidIcon from '../../../assets/departureWifi/icon_setting_and.png';
import { WIFI } from '@/constant/departure.const';
import ArrowIcon from '../../../assets/departureWifi/icon_arrow.png';

type Props = {
  size?: 'sm' | 'md';
  place?: 'airport' | 'port';
};

function AndroidWifiConnection({ size = 'md', place = 'airport' }: Props) {
  return (
    <WifiList>
      <WifiItem size={size}>
        <WifiDescription size={size}>
          <Div>
            <img
              src={SettingAndroidIcon}
              alt=''
              width={size === 'md' ? 24 : 16}
            />{' '}
            설정
          </Div>
          <img src={ArrowIcon} width={12} alt='' />
          <Div>
            <img src={WifiAndroidIcon} alt='' width={size === 'md' ? 24 : 16} />{' '}
            연결
          </Div>
          <img src={ArrowIcon} width={12} alt='' />
          <Div>하단 와이파이 연결</Div>
        </WifiDescription>
        <WifiName size={size}>
          <img src={WifiAndroidIcon} alt='' width={24} />
          {WIFI[place]}
        </WifiName>
      </WifiItem>
    </WifiList>
  );
}

const WifiList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 12px;
  background-color: #f5f6f7;
  width: 100%;
`;

const WifiItem = styled.li<{ size: 'sm' | 'md' }>`
  display: flex;
  flex-direction: column;
  gap: ${({ size = 'md' }) => (size === 'md' ? '24px' : '16px')};
`;

const WifiDescription = styled.dt<{ size: 'sm' | 'md' }>`
  font-size: ${({ size = 'md' }) => (size === 'md' ? '16px' : '12px')};
  font-weight: 600;
  color: #3a3b3e;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const WifiName = styled.dd<{ size: 'sm' | 'md' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ size = 'md' }) => (size === 'md' ? '16px' : '12px')};
  background-color: #ffffff;
  border-radius: 6px;
  font-size: ${({ size = 'md' }) => (size === 'md' ? '16px' : '12px')};
  color: #030303;
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export default AndroidWifiConnection;
